(() => {
  const loader =
    document.currentScript ||
    document.querySelector("script[data-price-slider-script]");
  const styleHref = loader?.dataset.priceSliderStyle;
  const numberScript = loader?.dataset.priceNumberScript;
  const sliderScript = loader?.dataset.priceSliderScript;
  let readyPromise;
  let pendingTrigger = null;

  const isReady = () => customElements.get("price-slider");
  const isScriptLoaded = (script) =>
    script.dataset.loaderReady === "true" ||
    script.readyState === "complete" ||
    script.readyState === "loaded" ||
    performance
      .getEntriesByName(script.src, "resource")
      .some((entry) => entry.responseEnd > 0);

  const loadStyle = () => {
    if (!styleHref) return Promise.resolve();
    const existing = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]'),
    ).find((link) => link.href === styleHref || link.getAttribute("href") === styleHref);
    if (existing) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = styleHref;
      style.addEventListener("load", resolve, { once: true });
      style.addEventListener("error", reject, { once: true });
      document.head.appendChild(style);
    });
  };

  const loadScript = (src, type = "text/javascript") =>
    new Promise((resolve, reject) => {
      if (!src) {
        resolve();
        return;
      }

      const existing = Array.from(document.scripts).find(
        (script) => script.src === src,
      );
      if (existing) {
        if (isScriptLoaded(existing)) {
          existing.dataset.loaderReady = "true";
          resolve();
          return;
        }
        existing.addEventListener(
          "load",
          () => {
            existing.dataset.loaderReady = "true";
            resolve();
          },
          { once: true },
        );
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.type = type;
      script.async = false;
      script.addEventListener(
        "load",
        () => {
          script.dataset.loaderReady = "true";
          resolve();
        },
        { once: true },
      );
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    });

  const load = () => {
    if (isReady()) return Promise.resolve();
    if (readyPromise) return readyPromise;

    readyPromise = Promise.all([
      loadStyle(),
      loadScript(numberScript).then(() => loadScript(sliderScript, "module")),
    ])
      .then(() => customElements.whenDefined("price-slider"))
      .catch((error) => {
        readyPromise = null;
        throw error;
      });

    return readyPromise;
  };

  const refreshVisibleSliders = () => {
    document.querySelectorAll("price-slider").forEach((el) => {
      if (typeof el.tryInit === "function") el.tryInit();
    });
  };

  const getPriceArea = (target) => target?.closest?.(".f-price-slider");
  const warm = (event) => {
    if (getPriceArea(event.target)) load().catch(() => undefined);
  };

  // iOS Safari: pointerover is unreliable; also warm on touchstart.
  document.addEventListener("pointerover", warm, {
    capture: true,
    passive: true,
  });
  document.addEventListener("touchstart", warm, {
    capture: true,
    passive: true,
  });
  document.addEventListener("focusin", warm, true);
  document.addEventListener(
    "pointerdown",
    (event) => {
      if (getPriceArea(event.target)) load().catch(() => undefined);
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    "click",
    (event) => {
      const trigger = event.target.closest(
        ".f-price-slider > .filter__header, .f-price-slider .wt-collapse__trigger",
      );
      if (!trigger || !getPriceArea(trigger)) return;

      // Already loaded: let the accordion open, then measure/init slider.
      if (isReady()) {
        requestAnimationFrame(() => {
          requestAnimationFrame(refreshVisibleSliders);
        });
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingTrigger) return;
      pendingTrigger = trigger;

      load()
        .then(() => {
          const target = pendingTrigger;
          pendingTrigger = null;
          if (!target?.isConnected) return;
          // Open the panel first so noUiSlider can measure a non-zero width.
          target.click();
          requestAnimationFrame(() => {
            requestAnimationFrame(refreshVisibleSliders);
          });
        })
        .catch(() => {
          pendingTrigger = null;
        });
    },
    true,
  );
})();
